import React from "react";
import { useTranslation } from "react-i18next";
import { RenderImage } from "go-app/components/ImageRenderer/ListImageName";
import { ReactComponent as AvatarSVG } from "../../../../../../../images/svg/public/order/avatar.svg";
import { OrderEmployee } from "../../../../../../../services/Api/Public/types";

interface Props {
	employee?: OrderEmployee;
	tipHeader: string;
}

const OrderTipEmployee = ({ employee, tipHeader }: Props) => {
	const { t } = useTranslation();

	return (
		<section className="order-employee-section" data-testid="e-order-employee-section">
			<div className="mb-4 avatar-container">
				{employee?.avatar_link ? (
					<RenderImage data={employee} variant="lg" imageLink={employee.avatar_link} />
				) : (
					<AvatarSVG data-testid="employee-avatar" />
				)}
			</div>
			<h1>{`${t("modules.e_order.field.tip_for.title")} ${
				employee?.name ?? t("modules.e_order.field.waiter.title")
			}`}</h1>
			<p className="text-muted">{tipHeader}</p>
		</section>
	);
};

export default OrderTipEmployee;
